import { CsvExportParams } from "./exportParams";

export interface ICsvCreator {
  getDataAsCsv(params?: CsvExportParams): string;
  exportDataAsCsv(params?: CsvExportParams): string;
}
